var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_attendanceModifiReason_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-attendance-modification-record"),
    },
    on: { new: _vm.toNew },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback) {
                  _vm.getList(page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.reason",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(
                                item.attendance_modification_reason_name
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.attendance_modification_reason_code",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "table-title text--primary" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.attendance_modification_reason_code) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn(
                            "delete-admin-attendance-modification-record"
                          ),
                          editBtn: _vm.hasBtn(
                            "edit-admin-attendance-modification-record"
                          ),
                          viewBtn: _vm.hasBtn(
                            "view-admin-attendance-modification-record"
                          ),
                          title: _vm.$t(
                            "label_essweb_attendanceModifiReason_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }